import React, { useCallback } from 'react';
import { AutoComplete, Input } from 'antd';
import { debounce } from 'lodash';

const AutoCompleteDebounce = ({ onSearch, ...props }) => {
  const debouncedHandleSearchChange = useCallback(
    debounce((val) => {
      if (onSearch) {
        onSearch(val);
      }
    }, 800),
    [onSearch]
  );

  return (
    <AutoComplete
      {...props}
      onSearch={debouncedHandleSearchChange}
    >
      {props.children}
    </AutoComplete>
  );
};

export default AutoCompleteDebounce;
